module.exports = __webpack_public_path__ + "img/MGCom.44da0f81.png";